/*
  WebGas: programmazione automatica della promo (ottobre 2026).

  Impostazioni tema > Badge promo (WebGas) > Programmazione automatica:
  orari "AAAA-MM-GG HH:MM" in ora italiana per prelancio, lancio, chiusura e fine.

  - Barra (sections/announcement-bar.liquid): il tema prepara una barra per stato,
    nascosta, con data-wg-from / data-wg-to. Qui si mostra quella della finestra in corso
    e si nasconde la barra normale ([data-wg-promo-default]); fuori dalle finestre resta
    la barra normale.
  - Badge (snippets/wg-promo-badge.liquid): con data-wg-from / data-wg-to compare solo
    dentro la finestra (classe is-live; senza classe lo nasconde il CSS).

  Lo script è caricato senza defer subito dopo la barra, quindi sceglie lo stato prima
  che la pagina venga disegnata; poi ricontrolla ogni minuto e quando la pagina aggiunge
  schede (filtri, anteprima rapida, consigliati nel carrello).
*/
(function () {
  var TZ = 'Europe/Rome';

  // Differenza in ms fra l'ora italiana e UTC in un dato istante
  function romeOffset(utcMs) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date(utcMs));
      var p = {};
      parts.forEach(function (x) { p[x.type] = x.value; });
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
      return asUtc - utcMs;
    } catch (e) {
      return 2 * 3600 * 1000;
    }
  }

  // "AAAA-MM-GG HH:MM" in ora italiana -> millisecondi UTC (NaN se vuoto o non valido)
  function parseRome(str) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})(?::(\d{2}))?)?\s*$/.exec(str || '');
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    var t = guess - romeOffset(guess);
    return guess - romeOffset(t);
  }

  function inWindow(el, now) {
    var from = parseRome(el.getAttribute('data-wg-from'));
    var to = parseRome(el.getAttribute('data-wg-to'));
    if (isNaN(from)) return false;
    return now >= from && (isNaN(to) || now < to);
  }

  function updateBar(now) {
    var slots = document.querySelectorAll('[data-wg-promo-slot]');
    if (!slots.length) return;
    var active = null;
    slots.forEach(function (slot) {
      var on = !active && inWindow(slot, now);
      if (on) active = slot;
      slot.hidden = !on;
    });
    document.querySelectorAll('[data-wg-promo-default]').forEach(function (bar) {
      bar.hidden = !!active;
    });
  }

  function updateBadges(now, root) {
    (root || document).querySelectorAll('.wg-promo-badge[data-wg-from]').forEach(function (b) {
      b.classList.toggle('is-live', inWindow(b, now));
    });
  }

  function update() {
    var now = Date.now();
    updateBar(now);
    updateBadges(now);
  }

  if (window.wgPromoSchedule) { update(); return; }
  window.wgPromoSchedule = { update: update, parseRome: parseRome };

  update();
  document.addEventListener('DOMContentLoaded', update);
  setInterval(update, 60000);

  // Schede aggiunte dopo il caricamento (filtri, anteprima rapida, carrello)
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; updateBadges(Date.now()); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
